export class Grades {
  // 小1
  static readonly S1: GradeMaster = {
    code: 's1',
    name: '小1',
    mathKeyboardName: 'math_primaryschool_lowerelementary',
  }
  // 小2
  static readonly S2: GradeMaster = {
    code: 's2',
    name: '小2',
    mathKeyboardName: 'math_primaryschool_lowerelementary',
  }
  // 小3
  static readonly S3: GradeMaster = {
    code: 's3',
    name: '小3',
    mathKeyboardName: 'math_primaryschool_lowerelementary',
  }
  // 小4
  static readonly S4: GradeMaster = {
    code: 's4',
    name: '小4',
    mathKeyboardName: 'math_primaryschool_upperelementary',
  }
  // 小5
  static readonly S5: GradeMaster = {
    code: 's5',
    name: '小5',
    mathKeyboardName: 'math_primaryschool_upperelementary',
  }
  // 小6
  static readonly S6: GradeMaster = {
    code: 's6',
    name: '小6',
    mathKeyboardName: 'math_primaryschool_upperelementary',
  }
  // 中1
  static readonly T1: GradeMaster = {
    code: 't1',
    name: '中1',
    mathKeyboardName: 'math',
  }
  // 中2
  static readonly T2: GradeMaster = {
    code: 't2',
    name: '中2',
    mathKeyboardName: 'math',
  }
  // 中3
  static readonly T3: GradeMaster = {
    code: 't3',
    name: '中3',
    mathKeyboardName: 'math',
  }
  // 学年一覧
  static readonly LIST = [
    Grades.S1,
    Grades.S2,
    Grades.S3,
    Grades.S4,
    Grades.S5,
    Grades.S6,
    Grades.T1,
    Grades.T2,
    Grades.T3,
  ]

  // コードで取得
  static findByCode(code: string): GradeMaster | undefined {
    return Grades.LIST.find((grade) => {
      return grade.code === code
    })
  }
}

export type GradeMaster = {
  // 学年コード
  code: string
  //  学年名
  name: string
  // 数学キーボード名
  mathKeyboardName: string
}
